import _ from "lodash";
import axios from "axios";
import Actions from "~app/constants/actions";

export const queryMediaGroups = () => _.throttle(async (dispatch) => {
    try {
        const result = await axios.get("/api/v1/media/groups");
        dispatch({
            type: Actions.MediaGroups.Query,
            payload: { models: result.data },
        });
    } catch (err) {
        console.log(err);
        dispatch({
            type: Actions.Error(Actions.MediaGroups.Query),
            payload: err,
        });
    }
}, 100);
